window.htmx = require('htmx.org');

//import { nossFilter } from 'helper/filter';
import { whenDocumentReady } from 'helper/documentready';
import { pawsFilter } from 'helper/pawsFilter';

whenDocumentReady(initPawsFilter);

function initPawsFilter() {
    let filterForms = document.querySelectorAll('form.filter');

    if (filterForms) {
        for (let filterForm = 0; filterForm < filterForms.length; ++filterForm) {
            pawsFilter(filterForms[filterForm]);
        }
    }
}

// update lazyload instance after swapping content
document.body.addEventListener('htmx:afterSwap', function(evt) {
    if (window.lazyLoadInstance) {
        window.lazyLoadInstance.update();
    }
});

document.body.addEventListener('htmx:afterRequest', function(evt) {
    if (evt.target.getAttribute('hx-target') == 'next .loadmore') {
        evt.target.setAttribute('hx-target', 'next .items');
        evt.target.removeAttribute('hx-swap');
        htmx.process(evt.target);
    }
});